import type { Time } from "../time";

import { type ClockTimeFormat, HourMinutesSeconds, getClockTimeFormat } from "./clock-time-format";
import { type CombinedDateTimeFormatWithTime, getCombinedDateTimeFormatWithTime } from "./combined-date-time-format";
import { getRelativeDateFormat } from "./date-format";

export interface FormatViewTimeProps {
	/** time to format */
	time: Time;
	/** the selected time of the view */
	viewTime: Time;
	/**
	 * TODO STAC-22104 make now required - extends RelativeTimeOptions
	 */
	now?: Time;
	/**
	 * @default HourMinutesSeconds
	 */
	clockTimeFormat?: ClockTimeFormat;
}

/**
 * Formats the time used within views relative to the selected and current (now) time.
 * The current and the selected time must be congruous to each other up to the point that the formatting
 * can be relative.
 *
 * E.g. if both current and selected are on the same day, the date will be formatted as "Today", but if the selected
 * time is yesterday then "Today" will not be used.
 *
 * Note: consider using the `FormatViewTime` react component.
 */
export function formatViewTime({
	time,
	viewTime,
	now = new Date(),
	clockTimeFormat = HourMinutesSeconds,
}: FormatViewTimeProps): CombinedDateTimeFormatWithTime {
	return getCombinedDateTimeFormatWithTime(
		time,
		getRelativeDateFormat({ viewTime, now }, time),
		getClockTimeFormat(clockTimeFormat),
	);
}
